<mat-toolbar class="topbar" [ngClass]="{'notDesktop': !isDesktopDevice}">
  <mat-toolbar-row class="topbar__row">
    <div class="logoWithButton">
        <button class="collapse-menu-btn" (click)="openedMenu = !openedMenu" *ngIf="!isDesktopDevice && (user['role'] === 'ROLE_SUPER_ADMIN' || user['role'] === 'ROLE_ADMIN' || user['role'] === 'ROLE_COORDINATOR' || user['role'] === 'ROLE_SALES_REPRESENTATIVE')">
            <mat-icon >menu</mat-icon>
        </button>
        <a routerLink="/">
          <img src="../../assets/logo-transparent.png" alt="" class="logo">
        </a>
    </div>

    <span class="headerText"><strong>EDUCATION SYSTEM</strong></span>
    <!-- <span class="bar-spacer"></span> -->
    <div>
      <button mat-button [matMenuTriggerFor]="appMenu">
        <span *ngIf="user">
          {{ user?.firstname }} {{ user?.lastname }} <img src="../../assets/user?.svg" class="userIcon" alt="">
        </span>
        <span *ngIf="user && user?.system_messages && user?.system_messages > 0" [matBadge]="user?.system_messages" matBadgeOverlap="false"></span>
      </button>
      <mat-menu #appMenu="matMenu" >
        <a *ngIf="user" routerLinkActive="active" routerLink="/profile/messages" mat-menu-item [matBadge]="user?.system_messages" matBadgeOverlap="false">powiadomienia</a>
        <a *ngIf="user" routerLinkActive="active" routerLink="/profile/change-password" mat-menu-item>zmień hasło</a>
        <button mat-menu-item (click)="logout()">wyloguj</button>
      </mat-menu>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<mat-sidenav-container class="layout" [ngClass]="{'notDesktop': !isDesktopDevice}" *ngIf="user && user?.role">

  <mat-sidenav mode="side" [opened]="isDesktopDevice || openedMenu" *ngIf="user && (user['role'] === 'ROLE_SUPER_ADMIN' || user['role'] === 'ROLE_ADMIN' || user['role'] === 'ROLE_COORDINATOR')">
    <mat-nav-list class="menu">
      <li><a routerLinkActive="active" routerLink="/dashboard">Pulpit</a></li>
      <li><a routerLinkActive="active" routerLink="/planner/{{ year }}">Planowanie</a></li>
      <li><a routerLinkActive="active" routerLink="/calendar">Kalendarz</a></li>
      <li><a routerLinkActive="active" routerLink="/trainings">Tematy szkoleń</a></li>
      <!-- <li>
        <a routerLinkActive="active" routerLink="/users">Użytkownicy</a>
        <ul>
          <li><a routerLinkActive="active" routerLink="/users/educators">EDUKATORZY</a></li>
          <li><a routerLinkActive="active" routerLink="/users/coordinators">REGIONALNI KOORDYNATORZY</a></li>
          <li><a routerLinkActive="active" routerLink="/users/traders">REPREZENTANT HANDLOWY</a></li>
          <li><a routerLinkActive="active" routerLink="/users/distributors">DYSTRYBUTORZY</a></li>
          <li><a routerLinkActive="active" routerLink="/users/emplayees">OSOBY Z BIURA</a></li>
        </ul>
      </li> -->
      <li><a routerLinkActive="active" routerLink="/localizations">Lokalizacje</a></li>
      <li><a routerLinkActive="active" routerLink="/distributors">Dystrybutorzy</a></li>
      <li>
        <a routerLinkActive="active" routerLink="/reports">Raporty</a>
        <ul>
          <li><a routerLinkActive="active" routerLink="/reports/client-frequency">Frekwencja na szkoleniach</a></li>
          <li><a routerLinkActive="active" routerLink="/reports/client-recent">Aktywność szkoleniowa salonów</a></li>
          <li><a routerLinkActive="active" routerLink="/reports/history-salon-training">Historia szkoleń salonu</a></li>
          <li><a routerLinkActive="active" routerLink="/reports/training-frequency">Frekwencja na szkoleniach - widok ogólny</a></li>
          <li><a routerLinkActive="active" routerLink="/reports/login">Logowanie użytkowników</a></li>

          <li><a routerLinkActive="active" routerLink="/reports/black-clients">Czarna lista</a></li>
          <li><a routerLinkActive="active" routerLink="/reports/participant-reservation">Uczestnicy dopisywani</a></li>

          <li><a routerLinkActive="active" routerLink="/reports/client-trained">Przeszkolone salony</a></li>
          <li><a routerLinkActive="active" routerLink="/reports/straznik">Strażnik</a></li>

          <li><a routerLinkActive="active" routerLink="/reports/training-online">online/offline</a></li>
          <li><a routerLinkActive="active" routerLink="/reports/new-clients">Lista nowych klientów</a></li>

          <li><a routerLinkActive="active" routerLink="/reports/popularity">Popularność szkoleń </a></li>
          <li><a routerLinkActive="active" routerLink="/reports/activity">Aktywność Edukatorów </a></li>

          <li><button class="link" (click)="getReport('kpi')" type="button">Raport KPI</button></li>
          <li><button class="link" (click)="getReport('main', 'csv')" type="button">Raport TBP</button></li>
        </ul>
      </li>
      <li *ngIf="permissionsService.hasAccess(user, 'ROLE_CONTACT_CAMPAIGN_LIST')">
        <a routerLinkActive="active" routerLink="/contact-campaign">Nowi klienci</a>
      </li>
      <li><a routerLinkActive="active" routerLink="/salons">Baza salonów</a></li>
      <li><a routerLinkActive="active" routerLink="/participants">Baza Fryzjerów</a></li>


      <li *ngIf="permissionsService.hasAccess(user, 'ROLE_JOINT_BUSINESS_PLAN_MODULE')">
        <a routerLinkActive="active" routerLink="/jbp">Joint Business Plan</a>
      </li>



    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav mode="side" [opened]="isDesktopDevice || openedMenu" *ngIf="user['role'] === 'ROLE_SALES_REPRESENTATIVE' || user['role'] === 'ROLE_DISTRIBUTOR' || user['role'] === 'ROLE_REGIONAL_MANAGER'">
    <mat-nav-list class="menu">

      <li><a routerLinkActive="active" routerLink="/calendar">Kalendarz</a></li>

      <li *ngIf="permissionsService.hasAccess(user, 'ROLE_CLIENT_DETAILS')">
        <a routerLinkActive="active" routerLink="/salons/list">Baza salonów</a>
      </li>


      <li *ngIf="permissionsService.hasAccess(user, 'ROLE_CONTACT_CAMPAIGN_LIST')">
        <a routerLinkActive="active" routerLink="/contact-campaign">Nowi klienci</a>
      </li>

      <li *ngIf="user['role'] === 'ROLE_REGIONAL_MANAGER'">
        <a routerLinkActive="active" routerLink="/reports/straznik">Raport Strażnik</a>
      </li>

      <li *ngIf="permissionsService.hasAccess(user, 'ROLE_JOINT_BUSINESS_PLAN_MODULE')">
        <a routerLinkActive="active" routerLink="/jbp">Joint Business Plan</a>
      </li>

    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content class="content">
    <div class="container {{ component }}">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
